import { Button } from "antd";

interface SaveButtonProps {
  onClick: () => void;
  loading?: boolean;
}

export default function SaveButton({ onClick, loading }: SaveButtonProps) {
  return (
    <div className="py-1">
      <Button onClick={onClick} type="link" loading={loading}>
        Save
      </Button>
    </div>
  );
}
